import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import { objectNotEmpty } from '../../../utilities/helpers';
import { boundariesCriteria, organisationTabCriteria, mobileAppCriteria } from '../../../utilities/epic-helpers';

import {
  FETCH_BRAND_AFFINITY_BRANDS_REPORT,
  FETCH_BRAND_AFFINITY_BRANDS_REPORT_ERROR,
  SET_BRAND_AFFINITY_BRANDS_REPORT
} from '../../constants';

const brandsReport = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_BRAND_AFFINITY_BRANDS_REPORT),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/brand-affinity/brands?${
          organisationTabCriteria(state$)
          }${
          boundariesCriteria(state$)
          }${
          `&period=${state$.value.brandAffinity.selectedPeriod.value}`
          }${
          objectNotEmpty(state$.value.insightsCriteria.baseline) === true
            ? `&baseline=${state$.value.insightsCriteria.baseline.value}`
            : ''
          }${
          mobileAppCriteria(state$)
          }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {
          return {
            type: SET_BRAND_AFFINITY_BRANDS_REPORT,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_BRAND_AFFINITY_BRANDS_REPORT_ERROR,
            error,
          })
        )
      )
    )
  );

export default brandsReport;
